import { themeColor } from "./_helpers";

export const uploadTokens = {
  bg: themeColor({
    base: "{colors.white}",
    _themeBlack: "{colors.whiteAlpha.100}",
    _themeWhite: "{colors.white}",
  }),
  border: themeColor({
    base: "{colors.neutral.100}",
    _themeBlack: "{colors.whiteAlpha.200}",
    _themeWhite: "{colors.neutral.200}",
  }),
  icon: themeColor({
    base: "{colors.neutral.400}",
    _themeBlack: "{colors.neutral.300}",
    _themeWhite: "{colors.neutral.500}",
  }),
  hoverBorder: themeColor({
    base: "{colors.primary.600}",
    _themeBlack: "{colors.primary.400}",
    _themeWhite: "{colors.primary.600}",
  }),
  hoverFg: themeColor({
    base: "{colors.primary.600}",
    _themeBlack: "{colors.primary.300}",
    _themeWhite: "{colors.primary.600}",
  }),
};
